// The Firebase SDK (Firestore + Auth) is ~250KB. It does NOT come with the first page load (main bundle) —
// it only downloads when needed (order save, login, reviews...). This greatly improves mobile speed
// (LCP / TBT).
let _firebase, _fs, _auth;
export const loadFirebase = () => _firebase || (_firebase = import('./firebase'));
export const loadFirestore = () =>
  _fs || (_fs = Promise.all([loadFirebase(), import('firebase/firestore')]).then(([f, s]) => ({ db: f.db, ...s })));
export const loadAuth = () =>
  _auth || (_auth = Promise.all([loadFirebase(), import('firebase/auth')]).then(([f, a]) => ({ auth: f.auth, ...a })));
